import { render } from "./DocumentClassChangeForm.vue?vue&type=template&id=5e499bc8&ts=true"
import script from "./DocumentClassChangeForm.vue?vue&type=script&lang=ts"
export * from "./DocumentClassChangeForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__